import React from 'react';

/**
 * This component is used to advance to a url on mount.
 */
export default function Forward({ href }) {
	React.useEffect(() => {
		window.location.href = href;
	}, []); //eslint-disable-line react-hooks/exhaustive-deps
	return null;
}